import { Reducer } from "react";
import {
    ADD_MEETING_FAIL, ADD_MEETING_REQUEST,
    ADD_MEETING_SUCCESS,













    BOOKMARK_SELECT_ITEM,
    CLEAR_MESSAGE,


    FILES_ADDED_MESSAGE, GET_MEETING_FAIL, GET_MEETING_REQUEST,
    GET_MEETING_SUCCESS,



    GET_TEAM_EVENTS_SUCCESS, GET_TEAM_EVENT_SUCCESS, Meeting, MeetingKnownAction, MeetingState,














    RECOMMENDATIONS_SELECT_ALL,
    RECOMMENDATIONS_SELECT_ITEM,


    REMOVE_MEETING_CONTENT_REQUEST,
    REMOVE_MEETING_CONTENT_SUCCESS, SELECT_BOOKMARK,
    SELECT_BOOKMARK_ADD,

    SELECT_RECOMMANDATION_STORY,







    UPDATE_MESSAGE, UPDATE_REMOVE_FILE_LIST,
    SELECTED_THEME
} from "./types";

const initialState: MeetingState = {
    adding: false,
    removing: false,
    message: "",
    loading: false,
    teamEvent: null,
    teamEvents: null,
    selectedDate: new Date(),
    selectedBookmarkId: 0,
    currentBookmarkSelection: [],
    selectRecommendedStory: 0,
    selectedFilesForRemove: [],
    selectedFiles: [],
    filesAddedMessage: "",
    theme : "",
    currentMeeting: ({
        meetingContents: [],
    } as unknown) as Meeting,
    error: {
        message: "",
        status: 0,
    },
};

const reducer: Reducer<MeetingState, MeetingKnownAction> = (
    state: MeetingState | undefined = initialState,
    action: MeetingKnownAction
) => {
    switch (action.type) {
        case ADD_MEETING_REQUEST:
            return {
                ...state,
                adding: true,
            };
        case ADD_MEETING_SUCCESS:
            return {
                ...state,
                adding: false,
                message: "Files successfully added to meeting",
                currentMeeting: action.payload,
                selectedFilesForRemove: state.selectedFilesForRemove.filter((item) => {
                    return !!action.payload.meetingContents.find(
                        (d) => d.fileId === item
                    );
                }),
            };
        case ADD_MEETING_FAIL:
            return {
                ...state,
                adding: false,
                error: action.error,
            };
        case GET_MEETING_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_MEETING_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.message,
                currentMeeting: action.payload,
                selectedFilesForRemove: state.selectedFilesForRemove.filter((item) => {
                    return !!(action.payload.meetingContents || []).find(
                        (d) => d.fileId === item
                    );
                }),
            };

        case GET_TEAM_EVENT_SUCCESS:
            return {
                ...state,
                teamEvent: action.payload,
            };

        case GET_TEAM_EVENTS_SUCCESS:
            return {
                ...state,
                teamEvents: action.payload,
                selectedDate: action.scheduledDate
            };

        case GET_MEETING_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case SELECT_RECOMMANDATION_STORY:
            return {
                ...state,
                selectedBookmarkId: 0,
                selectedFiles: action.files.map((row) => {
                    return {
                        id: row,
                        storyId: action.storyId,
                        checked: false,
                    };

                }),
                selectRecommendedStory: action.storyId,
            };
        case SELECT_BOOKMARK:
            return {
                ...state,
                selectRecommendedStory: 0,
                selectedFiles: action.items.map((row) => {
                    return {
                        id: row.id,
                        storyId: row.storyId,
                        checked: false
                    };
                }),
                selectedBookmarkId: action.bookmarkId,
            };

        case SELECT_BOOKMARK_ADD:
            let selectedFilesForAdding = state.selectedFiles;
            action.items.map((row) => {
                selectedFilesForAdding.push(row);
            });
            return {
                ...state,
                selectedFiles: selectedFilesForAdding,
                selectedBookmarkId: action.bookmarkId,
            };



        case UPDATE_REMOVE_FILE_LIST:
            let selectedFilesForRemove = state.selectedFilesForRemove;
            if (action.action === "add") {
                selectedFilesForRemove.push(action.fileId);
            } else {
                selectedFilesForRemove = selectedFilesForRemove.filter(
                    (c) => c !== action.fileId
                );
            }
            return {
                ...state,
                selectedFilesForRemove,
            };
        case RECOMMENDATIONS_SELECT_ALL:
            return {
                ...state,
                selectedFiles: state.selectedFiles.map((item) => {
                    return {
                        id: item.id,
                        storyId: item.storyId,
                        checked: action.payload,
                    };
                }),
            };
        case RECOMMENDATIONS_SELECT_ITEM:
            return {
                ...state,
                selectedFiles: state.selectedFiles.map((item) => {
                    return {
                        id: item.id,
                        storyId: item.storyId,
                        checked: item.id === action.fileId ? action.checked : item.checked,
                    };
                }),
            };

        case BOOKMARK_SELECT_ITEM:
            return {
                ...state,
                selectedFiles: state.selectedFiles.map((item) => {
                    return {
                        id: item.id,
                        storyId: item.storyId,
                        checked: item.storyId === action.storyId ? action.checked : item.checked,
                    };
                }),
            };

        case FILES_ADDED_MESSAGE:
            return {
                ...state,
                filesAddedMessage: action.filesAddedMessage,
                currentBookmarkSelection: action.currentBookmarkSelection
            };

        case SELECTED_THEME:
            return {
                ...state,
                theme: action.theme,
            };


        case CLEAR_MESSAGE:
            return {
                ...state,
                message: "",
            };
        case REMOVE_MEETING_CONTENT_REQUEST:
            return {
                ...state,
                removing: true,
            };
        case REMOVE_MEETING_CONTENT_SUCCESS:
            return {
                ...state,
                removing: false,
            };

        case UPDATE_MESSAGE:
            return {
                ...state,
                message: action.message
            }

        default:
            return state;
    }
};

export default reducer;
